var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    cx: 107.43,
    cy: 113.19,
    r: 57.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M201.72,277.45c0-58.66-42.22-106.21-94.3-106.21 s-94.3,47.55-94.3,106.21H201.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeMiterlimit: 10,
    d: "M276.12,105.19l-8.96-5.17c1.14-4.79,1.76-9.79,1.76-14.93 s-0.62-10.14-1.76-14.93l8.96-5.17c4.07-2.35,5.46-7.55,3.11-11.62l-9.88-17.11c-2.35-4.07-7.55-5.46-11.62-3.11l-8.97,5.18 c-7.23-6.85-16.05-12.03-25.85-14.94V13.04c0-4.7-3.81-8.5-8.5-8.5h-19.76c-4.7,0-8.5,3.81-8.5,8.5v10.34 c-9.8,2.92-18.61,8.1-25.85,14.94l-8.97-5.18c-4.07-2.35-9.27-0.95-11.62,3.11l-9.88,17.11c-1.16,2.02-1.41,4.31-0.86,6.39 c21.14,8.53,36.07,29.23,36.07,53.43c0,6.95-1.23,13.61-3.49,19.78c6.99,6.28,15.35,11.08,24.6,13.83v10.34 c0,4.7,3.81,8.5,8.5,8.5h19.76c4.7,0,8.5-3.81,8.5-8.5v-10.34c9.8-2.92,18.61-8.1,25.85-14.94l8.97,5.18 c4.07,2.35,9.27,0.95,11.62-3.11l9.88-17.11C281.58,112.74,280.19,107.54,276.12,105.19z M204.53,115.47 c-16.78,0-30.38-13.6-30.38-30.38c0-16.78,13.6-30.38,30.38-30.38c16.78,0,30.38,13.6,30.38,30.38 C234.91,101.87,221.31,115.47,204.53,115.47z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAuth);
export default __webpack_public_path__ + "static/media/UserAuth.364ad51cd6b9631e3aaf7b2fa13556aa.svg";
export { ForwardRef as ReactComponent };